import moment from 'moment-timezone';
import { FileDownloadSummaryApiModel } from '../../../api/accounts/models/file-download-summary-api.model';

export enum FileDownloadStatusEnum {
    IN_PROGRESS = 'IN_PROGRESS',
    READY_TO_DOWNLOAD = 'READY_TO_DOWNLOAD',
    FAILED = 'FAILED'
}

export class FileDownloadSummaryModel {
    uuid: string;
    mediaId: string;
    name: string;
    requestDateMS: number;
    requestDateDisplayString: string;
    expiryDateMS: number;
    expiryDateDisplayString: string;
    status: FileDownloadStatusEnum;
    statusStyleClass: string;
    statusTooltipText: string;
    downloadUrl: string;

    constructor(apiModel: FileDownloadSummaryApiModel) {
        if (apiModel) {
            this.uuid = apiModel.uuid;
            this.mediaId = apiModel.mediaId;
            this.name = apiModel.name;
            this.requestDateMS = apiModel.createdDateMS;
            this.expiryDateMS = apiModel.expiryDateMS;
            this.status = apiModel.status;
            this.downloadUrl = apiModel.downloadUrl;
        }
    }
}
